import React from "react";
import logger from "logger";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputBase from "@material-ui/core/InputBase";

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);

export default class Component extends React.Component {
  constructor(props) {
    super();
    this.state = {
      selectedValue: null,
    };
  }

  render = () => {
    const props = this.props;
    const ngModel = props["ng-model"];

    logger.log("props", props);

    let value = "placeholder";
    props.options.forEach((element, index) => {
      if (JSON.stringify(ngModel) === JSON.stringify(element.value)) {
        value = index;
      }
    });

    const enabled = props.options && props.options.length > 0;

    logger.log("value", value);

    return (
      <>
        <FormControl className="fullWidth">
          <Select
            disabled={!enabled}
            value={value}
            onChange={(event) => {
              logger.log("asdsfdf", event.target.value);
              props.onChange(props.options[event.target.value]);
            }}
            input={<BootstrapInput />}
            style={{margin:"5px"}}
          >
            {props.placeholder && (
              <MenuItem value="placeholder" disabled selected>
                <em>{props.placeholder}</em>
              </MenuItem>
            )}
            {props.options.map((option, index) => {
              const { label, value } = option;
              return <MenuItem value={index}>{label}</MenuItem>;
            })}
          </Select>
        </FormControl>
      </>
    );
  };
}
